/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import CloseIcon from '@mui/icons-material/Close'
import DoneRoundedIcon from '@mui/icons-material/DoneRounded'
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb'
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import RectangleRoundedIcon from '@mui/icons-material/RectangleRounded'
import SearchIcon from '@mui/icons-material/Search'
import 'react-multi-date-picker/styles/layouts/mobile.css'
import {
  Backdrop,
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Pagination,
  Stack,
  styled,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { Formik } from 'formik'
import L, { circle } from 'leaflet'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import qs from 'qs'
import React, { FC, useEffect, useState, useTransition } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { FeatureGroup, MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import InputIcon from 'react-multi-date-picker/components/input_icon'
import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import * as Yup from 'yup'

import iranflag12 from '../../assests/icons/12.png'
import iranflag2 from '../../assests/icons/2.png'
import iranflag24 from '../../assests/icons/24.png'
import iranflag48 from '../../assests/icons/48.png'
import iranflag6 from '../../assests/icons/6.png'
import imageIcon1 from '../../assests/icons/markerred.png'
import * as routes from '../../config/constants'
import ExcelExportDevice from '../../ExcelExportDevice'
import ExcelJsExport from '../../ExcelJsExport'
import { IsCarItem } from '../../interfaces/IsCarItem'
import { IsItem } from '../../interfaces/IsItem'
import { IsServiceItem } from '../../interfaces/IsServiceItem'
import Input from '../../shared/Input'
import Select from '../../shared/Select'
import {
  getIsUserInfo,
  getUserInfo,
  receiveAppToken,
  refreshToken,
  setLogged,
} from '../../store/auth'
import store from '../../store/configureStore'
import {
  deviceList,
  devicePaginatedList,
  getDeviceList,
  getDevicePaginated,
  getdeviceSearch,
  getLastPosition,
  getLoading,
  getPaginatedList,
  getRefreshToken,
  getSearchPosition,
  resetLastPositionSearch,
  searchDevice,
  searchPosition,
} from '../../store/devices'
import LoginScreen from '../auth/LoginScreen'
import CarItem1 from './CarItem1'
// لیست خودروها براساس مقادیر

const modelTypes: IsCarItem[] = [
  { id: '46', label: 'پراید', value: '10', company: 'saipa' },
  { id: '47', label: 'پراید 111', value: '11', company: 'saipa' },
  { id: '48', label: 'پراید 132', value: '12', company: 'saipa' },
  { id: '49', label: 'پراید 131', value: '13', company: 'saipa' },
  { id: '50', label: 'پراید 151', value: '14', company: 'saipa' },
  { id: '51', label: 'تيبا', value: '15', company: 'saipa' },
  { id: '52', label: 'ساينا', value: '16', company: 'saipa' },
  { id: '53', label: 'Z300 زوتي ', value: '17', company: 'saipa' },
  { id: '54', label: ' H320 برليانس ', value: '18', company: 'saipa' },
  { id: '55', label: 'H230 برليانس', value: '19', company: 'saipa' },
  { id: '56', label: 'H330 برليانس', value: '20', company: 'saipa' },
  { id: '57', label: 'H220 برليانس', value: '21', company: 'saipa' },
  { id: '58', label: 'V5 برليانس', value: '22', company: 'saipa' },
  { id: '59', label: 'نيسان بنزینی', value: '23', company: 'saipa' },
  { id: '60', label: 'نيسان ديزل', value: '24', company: 'saipa' },
  { id: '61', label: 'تندر 90', value: '25', company: 'saipa' },
  { id: '62', label: 'CS35 چانگان ', value: '26', company: 'saipa' },
  { id: '63', label: 'ريو', value: '27', company: 'saipa' },
  { id: '64', label: 'کوييک', value: '28', company: 'saipa' },
  { id: '65', label: '2 تیبا ', value: '29', company: 'saipa' },
  { id: '66', label: 'زانتیا ', value: '30', company: 'saipa' },
  { id: '67', label: 'C5 سیتروئن ', value: '31', company: 'saipa' },
  { id: '68', label: 'C3 سیتروئن ', value: '32', company: 'saipa' },
  { id: '69', label: 'نیسان پادرا ', value: '33', company: 'saipa' },
  { id: '70', label: 'شاهین ', value: '34', company: 'saipa' },
  { id: '71', label: 'پيکان ', value: '47', company: 'iran-Khodro' },
  { id: '72', label: 'پيکان وانت ', value: '48', company: 'iran-Khodro' },
  { id: '73', label: 'سمند ', value: '49', company: 'iran-Khodro' },
  { id: '74', label: 'سرير ', value: '50', company: 'iran-Khodro' },
  { id: '75', label: 'سورن ', value: '51', company: 'iran-Khodro' },
  { id: '76', label: 'پژو پارس ', value: '52', company: 'iran-Khodro' },
  { id: '77', label: 'آریسان', value: '53', company: 'iran-Khodro' },
  { id: '78', label: 'پژو 206 ', value: '54', company: 'iran-Khodro' },
  { id: '79', label: 'پژو 207 ', value: '55', company: 'iran-Khodro' },
  { id: '80', label: 'تندر 90 ', value: '56', company: 'iran-Khodro' },
  { id: '81', label: 'دنا ', value: '58', company: 'iran-Khodro' },
  { id: '82', label: 'دنا پلاس ', value: '57', company: 'iran-Khodro' },
  { id: '83', label: 'رانا ', value: '59', company: 'iran-Khodro' },
  { id: '84', label: 'S5 هایما ', value: '60', company: 'iran-Khodro' },
  { id: '85', label: 'S7 هایما ', value: '61', company: 'iran-Khodro' },
  { id: '86', label: 'دستی H30 دانگ فنگ ', value: '62', company: 'iran-Khodro' },
  { id: '87', label: 'اتوماتیک H30 دانگ فنگ  ', value: '63', company: 'iran-Khodro' },
  { id: '89', label: 'روا ', value: '65', company: 'iran-Khodro' },
  { id: '90', label: 'آردی ', value: '66', company: 'iran-Khodro' },
  { id: '91', label: 'تارا ', value: '67', company: 'iran-Khodro' },
  { id: '92', label: 'چری ویانا ', value: '68', company: 'iran-Khodro' },
  { id: '93', label: '301 پژو  ', value: '69', company: 'iran-Khodro' },
  { id: '94', label: '508 پژو ', value: '70', company: 'iran-Khodro' },
  { id: '95', label: 'S5 AT هایما ', value: '71', company: 'iran-Khodro' },
  { id: '96', label: 'رانا پلاس ', value: '72', company: 'iran-Khodro' },
  { id: '97', label: 'سورن پلاس ', value: '73', company: 'iran-Khodro' },
  { id: '98', label: 'سورن توربو ', value: '74', company: 'iran-Khodro' },
  { id: '99', label: ' تندر 90 اتوماتیک  ', value: '75', company: 'iran-Khodro' },
  { id: '100', label: 'تندر پلاس دنده ', value: '76', company: 'iran-Khodro' },
  { id: '101', label: 'تندر پلاس اتوماتیک ', value: '77', company: 'iran-Khodro' },
  { id: '102', label: '2000cc سوزوکی گرند ویتارا دستی  ', value: '78', company: 'iran-Khodro' },
  { id: '103', label: '2000cc سوزوکی گرند ویتارا اتوماتیک ', value: '79', company: 'iran-Khodro' },
  { id: '104', label: '2400cc سوزوکی گرند ویتارا دستی ', value: '80', company: 'iran-Khodro' },
  { id: '105', label: '2400cc سوزوکی گرند ویتارا اتوماتیک ', value: '81', company: 'iran-Khodro' },
  { id: '106', label: '407 پژو ', value: '82', company: 'iran-Khodro' },
  { id: '107', label: '405 پژو ', value: '83', company: 'iran-Khodro' },
  { id: '108', label: 'SLX 405 پژو ', value: '84', company: 'iran-Khodro' },
  { id: '109', label: 'سوزوکی کیزاشی ', value: '85', company: 'iran-Khodro' },
  { id: '110', label: 'رنو کپچر ', value: '86', company: 'iran-Khodro' },
  { id: '111', label: 'تندر نود استیشن ', value: '87', company: 'iran-Khodro' },
  { id: '1111', label: 'وانت تندر نود ', value: '88', company: 'iran-Khodro' },
  { id: '1112', label: 'S7 PLUS هایما', value: '89', company: 'iran-Khodro' },
  { id: '1113', label: '2008 پژو', value: '90', company: 'iran-Khodro' },
  { id: '112', label: 'کاپرا ', value: '100', company: 'bahman' },
  { id: '113', label: 'مزدا کارا پيکاپ ', value: '101', company: 'bahman' },
  { id: '114', label: 'سيباون ', value: '102', company: 'bahman' },
  { id: '115', label: 'B5 آسا ', value: '103', company: 'bahman' },
  { id: '116', label: 'نارون  ', value: '104', company: 'bahman' },
  { id: '117', label: 'Caro مینی تراک ', value: '105', company: 'bahman' },
  { id: '118', label: 'وانت ایسوزو ', value: '106', company: 'bahman' },
  { id: '119', label: '30 بسترن بی  ', value: '107', company: 'bahman' },
  { id: '120', label: 'فیدلیتی ', value: '108', company: 'bahman' },
  { id: '121', label: 'دیگنیتی ', value: '109', company: 'bahman' },
  { id: '122', label: 'دیگنیتی پرستیژ ', value: '110', company: 'bahman' },
  { id: '123', label: '50F بسترن بی ', value: '111', company: 'bahman' },
  { id: '124', label: '50 بسترن بی ', value: '112', company: 'bahman' },
  { id: '125', label: '2 مزدا ', value: '113', company: 'bahman' },
  { id: '126', label: '3 مزدا ', value: '114', company: 'bahman' },
  { id: '127', label: 'مزدا 3 جدید', value: '115', company: 'bahman' },
  { id: '128', label: 'کاپرا 2 ', value: '116', company: 'bahman' },
  { id: '129', label: 'H2 هاوال  ', value: '117', company: 'bahman' },
  { id: '130', label: 'ریسپکت پرایم  ', value: '118', company: 'bahman' },
  { id: '131', label: 'x33 ام وی ام  ', value: '128', company: 'mvm' },
  { id: '132', label: '110 ام وی ام  ', value: '129', company: 'mvm' },
  { id: '133', label: 'x22 ام وی ام  ', value: '130', company: 'mvm' },
  { id: '134', label: '315 ام وی ام  ', value: '131', company: 'mvm' },
  { id: '135', label: '530 ام وی ام  ', value: '132', company: 'mvm' },
  { id: '136', label: '550 ام وی ام  ', value: '133', company: 'mvm' },
  { id: '137', label: '110s ام وی ام  ', value: '134', company: 'mvm' },
  { id: '138', label: 'x22 pro ام وی ام  ', value: '135', company: 'mvm' },
  { id: '139', label: 'x55 ام وی ام  ', value: '136', company: 'mvm' },
  { id: '140', label: 'x55 pro ام وی ام  ', value: '137', company: 'mvm' },
  { id: '141', label: 'ام و ام 530 دستی  ', value: '138', company: 'mvm' },
  { id: '142', label: 'دستی X22 ام وی ام ', value: '139', company: 'mvm' },
  { id: '143', label: '5 آریزو  ', value: '146', company: 'chery' },
  { id: '144', label: '5 تیگو  ', value: '147', company: 'chery' },
  { id: '145', label: 'آریزو 5 دنده', value: '148', company: 'chery' },
  { id: '146', label: 'آریزو 5 توربو  ', value: '149', company: 'chery' },
  { id: '147', label: 'آریزو 6  ', value: '150', company: 'chery' },
  { id: '148', label: 'تیگو 7  ', value: '151', company: 'chery' },
  { id: '149', label: 'تیگو 8  ', value: '152', company: 'chery' },
  { id: '150', label: 'H30 دستی ', value: '158', company: 'dongFang' },
  { id: '151', label: 'H30 اتوماتیک', value: '159', company: 'dongFang' },
  { id: '152', label: 'S30', value: '160', company: 'dongFang' },
  { id: '153', label: 'E60', value: '166', company: 'bmw' },
  { id: '154', label: 'E61', value: '167', company: 'bmw' },
  { id: '155', label: 'E230(2006)', value: '168', company: 'bmw' },
  { id: '156', label: '125i  coupe', value: '169', company: 'bmw' },
  { id: '157', label: '116i ', value: '170', company: 'bmw' },
  { id: '158', label: '118i manual', value: '171', company: 'bmw' },
  { id: '159', label: '120i ', value: '172', company: 'bmw' },
  { id: '160', label: '125i  ', value: '173', company: 'bmw' },
  { id: '161', label: '218i activetourer', value: '174', company: 'bmw' },
  { id: '162', label: '220i convertible', value: '175', company: 'bmw' },
  { id: '163', label: '228i convertible', value: '176', company: 'bmw' },
  { id: '164', label: '230i covertible', value: '177', company: 'bmw' },
  { id: '165', label: '220i coupe', value: '178', company: 'bmw' },
  { id: '166', label: '318i sedan ', value: '179', company: 'bmw' },
  { id: '167', label: '320i sedan', value: '180', company: 'bmw' },
  { id: '168', label: '325i sedan', value: '181', company: 'bmw' },
  { id: '169', label: '328i sedan', value: '182', company: 'bmw' },
  { id: '170', label: '330i sedan', value: '183', company: 'bmw' },
  { id: '171', label: '320i covertible', value: '184', company: 'bmw' },
  { id: '172', label: '325i convertible', value: '185', company: 'bmw' },
  { id: '173', label: '330i convertible', value: '186', company: 'bmw' },
  { id: '174', label: '335i covertible', value: '187', company: 'bmw' },
  { id: '175', label: '320i coupe', value: '188', company: 'bmw' },
  { id: '176', label: '325i coupe', value: '189', company: 'bmw' },
  { id: '177', label: '330i coupe', value: '190', company: 'bmw' },
  { id: '178', label: '335i coupe', value: '191', company: 'bmw' },
  { id: '179', label: '328i GT', value: '192', company: 'bmw' },
  { id: '180', label: '420i covertible ', value: '193', company: 'bmw' },
  { id: '181', label: '428i convertible', value: '194', company: 'bmw' },
  { id: '182', label: '420i coupe', value: '195', company: 'bmw' },
  { id: '183', label: '428i coupe', value: '196', company: 'bmw' },
  { id: '184', label: '420i grancoupe', value: '197', company: 'bmw' },
  { id: '185', label: '428i grancoupe', value: '198', company: 'bmw' },
  { id: '186', label: '518i sedan', value: '199', company: 'bmw' },
  { id: '187', label: '520i sedan', value: '200', company: 'bmw' },
  { id: '188', label: '523i sedan', value: '201', company: 'bmw' },
  { id: '189', label: '525i sedan', value: '202', company: 'bmw' },
  { id: '190', label: '528i sedan', value: '203', company: 'bmw' },
  { id: '191', label: '530i sedan', value: '204', company: 'bmw' },
  { id: '192', label: '535i sedan', value: '205', company: 'bmw' },
  { id: '193', label: '540i sedan', value: '206', company: 'bmw' },
  { id: '194', label: '528i GT', value: '207', company: 'bmw' },
  { id: '195', label: '630i convertible', value: '208', company: 'bmw' },
  { id: '196', label: '650i convertible', value: '209', company: 'bmw' },
  { id: '197', label: '630i coupe ', value: '210', company: 'bmw' },
  { id: '198', label: '640i coupe', value: '211', company: 'bmw' },
  { id: '199', label: '650i coupe', value: '212', company: 'bmw' },
  { id: '200', label: '640i grancoupe', value: '213', company: 'bmw' },
  { id: '201', label: '650i grancoupe', value: '214', company: 'bmw' },
  { id: '202', label: '730i', value: '215', company: 'bmw' },
  { id: '203', label: '730li', value: '216', company: 'bmw' },
  { id: '204', label: '740li', value: '217', company: 'bmw' },
  { id: '205', label: '750li', value: '218', company: 'bmw' },
  { id: '206', label: '760li', value: '219', company: 'bmw' },
  { id: '207', label: 'i8', value: '220', company: 'bmw' },
  { id: '208', label: 'X1 1.8l', value: '221', company: 'bmw' },
  { id: '209', label: 'X1 2.0l', value: '222', company: 'bmw' },
  { id: '210', label: 'X1 2.5l', value: '223', company: 'bmw' },
  { id: '211', label: 'X1 2.8l', value: '224', company: 'bmw' },
  { id: '212', label: 'X3 2.0l', value: '225', company: 'bmw' },
  { id: '213', label: 'X3 2.5l', value: '226', company: 'bmw' },
  { id: '214', label: 'X3 2.8l', value: '227', company: 'bmw' },
  { id: '215', label: 'X3 3.0l', value: '228', company: 'bmw' },
  { id: '216', label: 'X4 2.8l', value: '229', company: 'bmw' },
  { id: '217', label: 'X5', value: '230', company: 'bmw' },
  { id: '218', label: 'X6 3.5l', value: '231', company: 'bmw' },
  { id: '219', label: 'X6 5.0l', value: '232', company: 'bmw' },
  { id: '220', label: 'Z4 2.0l', value: '233', company: 'bmw' },
  { id: '221', label: 'Z4 2.3l', value: '234', company: 'bmw' },
  { id: '222', label: 'Z4 2.8l', value: '235', company: 'bmw' },
  { id: '223', label: 'Z4 3.5l', value: '236', company: 'bmw' },
  { id: '224', label: 'EC7 جيلي ام گراند ', value: '249', company: 'jili' },
  { id: '225', label: 'جیلی امگرند 7 دنده ', value: '250', company: 'jili' },
  { id: '226', label: 'جیلی امگرند 7 اتوماتیک ', value: '251', company: 'jili' },
  { id: '227', label: '8 جیلی امگرند', value: '252', company: 'jili' },
  { id: '228', label: 'دنده RV-7 امگرند ', value: '253', company: 'jili' },
  { id: '229', label: 'اتوماتیک RV-7 امگرند', value: '254', company: 'jili' },
  { id: '230', label: 'X7 امگرند', value: '255', company: 'jili' },
  { id: '231', label: 'الیت GC6 جیلی', value: '256', company: 'jili' },
  { id: '232', label: 'اکسلنت GC6 جیلی', value: '257', company: 'jili' },
  { id: '233', label: 'B30 بسترن', value: '265', company: 'faw' },
  { id: '234', label: 'B50 بسترن', value: '266', company: 'faw' },
  { id: '235', label: 'B50F بسترن', value: '267', company: 'faw' },
  { id: '236', label: 'wingel5', value: '274', company: 'gratewall' },
  { id: '237', label: 'وانت دییر', value: '275', company: 'gratewall' },
  { id: '238', label: '3 وینگل', value: '276', company: 'gratewall' },
  { id: '239', label: 'وینگل 5 تک کابین', value: '277', company: 'gratewall' },
  { id: '240', label: 'وینگل 5 دو کابین', value: '278', company: 'gratewall' },
  { id: '241', label: 'H6 هاوال', value: '279', company: 'gratewall' },
  { id: '242', label: '(مونتاژ) M4 هاوال', value: '280', company: 'gratewall' },
  { id: '243', label: 'c30', value: '281', company: 'gratewall' },
  { id: '244', label: 'J4 جک', value: '289', company: 'kerman' },
  { id: '245', label: 'J5 جک', value: '290', company: 'kerman' },
  { id: '246', label: 'S5 جک', value: '291', company: 'kerman' },
  { id: '247', label: 'S3 جک', value: '292', company: 'kerman' },
  { id: '248', label: 'X60 لیفان', value: '293', company: 'kerman' },
  { id: '249', label: '620 لیفان', value: '294', company: 'kerman' },
  { id: '250', label: 'X50 لیفان لیفان', value: '295', company: 'kerman' },
  { id: '251', label: '520 لیفان', value: '296', company: 'kerman' },
  { id: '252', label: '820 لیفان', value: '297', company: 'kerman' },
  { id: '253', label: '2000 دوو اسپرو', value: '298', company: 'kerman' },
  { id: '254', label: 'دوو ريستر', value: '299', company: 'kerman' },
  { id: '255', label: 'دوو سيلو', value: '300', company: 'kerman' },
  { id: '256', label: 'آوانته', value: '301', company: 'kerman' },
  { id: '257', label: 'ورنا', value: '302', company: 'kerman' },
  { id: '258', label: 'دوو ماتیز', value: '303', company: 'kerman' },
  { id: '259', label: 'النترا', value: '304', company: 'kerman' },
  { id: '260', label: 'i10', value: '305', company: 'kerman' },
  { id: '261', label: 'i20', value: '306', company: 'kerman' },
  { id: '262', label: 'T8 جک', value: '307', company: 'kerman' },
  { id: '263', label: 'S7 جک', value: '308', company: 'kerman' },
  { id: '264', label: 'K7 جک', value: '309', company: 'kerman' },
  { id: '265', label: 'دستی S5 جک', value: '310', company: 'kerman' },
  { id: '266', label: '2000 تونلند', value: '317', company: 'foton' },
  { id: '267', label: '2400 تونلند', value: '318', company: 'foton' },
  { id: '268', label: '2800 تونلند', value: '319', company: 'foton' },
  { id: '269', label: 'ساوانا اتوماتیک', value: '320', company: 'foton' },
  { id: '270', label: 'تاليسمان', value: '329', company: 'reno' },
  { id: '271', label: 'مگان وارداتی', value: '330', company: 'reno' },
  { id: '272', label: 'ساندرو', value: '331', company: 'reno' },
  { id: '273', label: '90 تندر', value: '332', company: 'reno' },
  { id: '274', label: 'مگان', value: '333', company: 'reno' },
  { id: '275', label: 'داستر', value: '334', company: 'reno' },
  { id: '276', label: '2400 سفران', value: '335', company: 'reno' },
  { id: '277', label: '2000 سفران', value: '336', company: 'reno' },
  { id: '278', label: 'لتیتود', value: '337', company: 'reno' },
  { id: '279', label: 'اسکالا کروک', value: '338', company: 'reno' },
  { id: '280', label: 'اسکالا هاچ بک 2000', value: '339', company: 'reno' },
  { id: '281', label: 'اسکالا هاچ بک 1600', value: '340', company: 'reno' },
  { id: '282', label: 'سیمبل', value: '341', company: 'reno' },
  { id: '283', label: 'لاگونا کوپه', value: '342', company: 'reno' },
  { id: '284', label: 'کولیوس 2011-2015', value: '343', company: 'reno' },
  { id: '285', label: 'کولیوس 2017-2018', value: '344', company: 'reno' },
  { id: '286', label: 'ساندرو استپ وی', value: '345', company: 'reno' },
  { id: '287', label: 'رنو مگان هاچ بک', value: '346', company: 'reno' },
  { id: '288', label: 'رنو مگان مونتاژ', value: '347', company: 'reno' },
  { id: '289', label: 'رنو فلوئنس', value: '348', company: 'reno' },
  { id: '290', label: 'رنو فلوئنس دنده ای', value: '349', company: 'reno' },
  { id: '291', label: 'تندر وانت', value: '350', company: 'reno' },
  { id: '292', label: 'پژو 206', value: '358', company: 'pegout' },
  { id: '293', label: 'پژو 207', value: '359', company: 'pegout' },
  { id: '294', label: 'پژو پارس', value: '360', company: 'pegout' },
  { id: '295', label: 'پژو 405', value: '361', company: 'pegout' },
  { id: '296', label: 'پژو 407', value: '362', company: 'pegout' },
  { id: '297', label: 'پژو 508', value: '363', company: 'pegout' },
  { id: '298', label: 'پژو 301', value: '364', company: 'pegout' },
  { id: '2981', label: '2008 پژو', value: '365', company: 'pegout' },
  { id: '299', label: 'ون دليکا', value: '370', company: 'asna' },
  { id: '300', label: 'آمیکو', value: '371', company: 'asna' },
  { id: '301', label: 'دستی J4 جک', value: '377', company: 'jac' },
  { id: '302', label: '(CVT) اتوماتیک J4 جک', value: '378', company: 'jac' },
  { id: '303', label: 'اتوماتیک J5 جک', value: '379', company: 'jac' },
  { id: '304', label: 'دستی J5 جک', value: '380', company: 'jac' },
  { id: '305', label: ' S5 جک', value: '381', company: 'jac' },
  { id: '306', label: ' S3 جک', value: '382', company: 'jac' },
  { id: '307', label: ' T8 جک', value: '383', company: 'jac' },
  { id: '308', label: ' K7 جک', value: '384', company: 'jac' },
  { id: '309', label: ' J7 جک', value: '385', company: 'jac' },
  { id: '310', label: ' دستی S5 جک', value: '386', company: 'jac' },
  { id: '311', label: ' وانت مزدا(زيمنس)', value: '393', company: 'mazda' },
  { id: '312', label: '323 مزدا', value: '394', company: 'mazda' },
  { id: '313', label: 'مزدا 3 جديد', value: '395', company: 'mazda' },
  { id: '314', label: 'مزدا 3 قدیم', value: '396', company: 'mazda' },
  { id: '315', label: 'مزدا 2 ', value: '397', company: 'mazda' },
  { id: '316', label: 'X60 لیفان ', value: '405', company: 'lifan' },
  { id: '317', label: '620 لیفان ', value: '406', company: 'lifan' },
  { id: '318', label: 'X50 لیفان ', value: '407', company: 'lifan' },
  { id: '319', label: '520 لیفان ', value: '408', company: 'lifan' },
  { id: '320', label: '820 لیفان ', value: '409', company: 'lifan' },
  { id: '321', label: 'X70 لیفان ', value: '410', company: 'lifan' },
  { id: '322', label: 'موسو ', value: '419', company: 'songyong' },
  { id: '323', label: 'cm600 چیرمن ', value: '420', company: 'songyong' },
  { id: '324', label: 'تيوولي ', value: '421', company: 'songyong' },
  { id: '325', label: 'نيو اکتيون ', value: '422', company: 'songyong' },
  { id: '326', label: 'نيو کوراندو ', value: '423', company: 'songyong' },
  { id: '327', label: 'اکتيون ', value: '424', company: 'songyong' },
  { id: '328', label: 'کراندو ', value: '425', company: 'songyong' },
  { id: '329', label: 'کراندو نیو ', value: '426', company: 'songyong' },
  { id: '330', label: 'تیوولی توربو فایتر ', value: '427', company: 'songyong' },
  { id: '331', label: 'تیوولی اسپیشیال ', value: '428', company: 'songyong' },
  { id: '332', label: 'رکستون ', value: '429', company: 'songyong' },
  { id: '333', label: 'G4 رکستون ', value: '430', company: 'songyong' },
  { id: '334', label: 'رکستون امپرور ', value: '431', company: 'songyong' },
  { id: '335', label: 'ردیوس ', value: '432', company: 'songyong' },
  { id: '336', label: 'تیوولی ', value: '433', company: 'songyong' },
  { id: '337', label: '(2009)LC70 لندکروز ', value: '440', company: 'toyota' },
  { id: '338', label: '(2010)LC200 لندکروز  ', value: '441', company: 'toyota' },
  { id: '339', label: 'هايلوکس ', value: '442', company: 'toyota' },
  { id: '340', label: 'کمري هيبريد(2015) ', value: '443', company: 'toyota' },
  { id: '341', label: 'پرادو-2012 ', value: '444', company: 'toyota' },
  { id: '342', label: 'تويوتا ياريس 2011 ', value: '445', company: 'toyota' },
  { id: '343', label: '(3UZ) موتور ', value: '446', company: 'toyota' },
  { id: '344', label: '(C,B,A تیپ) پریوس هیبرید ', value: '447', company: 'toyota' },
  { id: '345', label: 'کمری', value: '448', company: 'toyota' },
  { id: '346', label: 'اریون اسپرت ', value: '449', company: 'toyota' },
  { id: '347', label: 'VX پرادو 2 درب ', value: '450', company: 'toyota' },
  { id: '348', label: 'GX پرادو 2 درب ', value: '451', company: 'toyota' },
  { id: '349', label: 'VX پرادو 4 درب ', value: '452', company: 'toyota' },
  { id: '350', label: 'GX پرادو 4 درب ', value: '453', company: 'toyota' },
  { id: '351', label: 'GLI کرولا ', value: '454', company: 'toyota' },
  { id: '352', label: 'XLI کرولا ', value: '455', company: 'toyota' },
  { id: '353', label: 'اف جی کروز ', value: '456', company: 'toyota' },
  { id: '354', label: 'پریویا ', value: '457', company: 'toyota' },
  { id: '355', label: 'توندرا ', value: '458', company: 'toyota' },
  { id: '356', label: 'راوفور ', value: '459', company: 'toyota' },
  { id: '357', label: 'فرچونر ', value: '460', company: 'toyota' },
  { id: '358', label: 'فررانر ', value: '461', company: 'toyota' },
  { id: '359', label: 'کارینا ', value: '462', company: 'toyota' },
  { id: '360', label: 'کراون0کرونا  ', value: '463', company: 'toyota' },
  { id: '361', label: 'هایس ', value: '464', company: 'toyota' },
  { id: '362', label: 'XA', value: '465', company: 'toyota' },
  { id: '363', label: 'GT86', value: '466', company: 'toyota' },
  { id: '364', label: 'کریسیدا ', value: '467', company: 'toyota' },
  { id: '365', label: 'یاریس صندوقدار ', value: '468', company: 'toyota' },
  { id: '366', label: 'یاریس هاچ بک ', value: '469', company: 'toyota' },
  { id: '367', label: 'C-HR  ', value: '470', company: 'toyota' },
  { id: '368', label: 'C-HR HYBRID ', value: '471', company: 'toyota' },
  { id: '369', label: 'اریون گرند ', value: '472', company: 'toyota' },
  { id: '370', label: 'هایلوکس تک کابین ', value: '473', company: 'toyota' },
  { id: '371', label: 'هایلوکس دو کابین دنده  ', value: '474', company: 'toyota' },
  { id: '372', label: 'هایلوکس دو کابین اتوماتیک ', value: '475', company: 'toyota' },
  { id: '373', label: 'هایلوکس دو کابین بلند دنده  ', value: '476', company: 'toyota' },
  { id: '374', label: 'هایلوکس دو کابین بلند اتوماتیک ', value: '477', company: 'toyota' },
  { id: '375', label: 'لندکروز 4 درب 6 سیلندر4000 ', value: '478', company: 'toyota' },
  { id: '376', label: 'لندکروز 4 درب 6 سیلندر4200 ', value: '479', company: 'toyota' },
  { id: '377', label: 'لندکروز 4 درب 6 سیلندر4500 ', value: '480', company: 'toyota' },
  { id: '378', label: 'لندکروز 4 درب 8 سیلندر4700 ', value: '481', company: 'toyota' },
  { id: '379', label: 'لندکروز 4 درب 8 سیلندر5700 ', value: '482', company: 'toyota' },
  { id: '380', label: '2F لندکروز 2 درب ', value: '483', company: 'toyota' },
  { id: '381', label: '3F لندکروز 2 درب ', value: '484', company: 'toyota' },
  { id: '382', label: '4/5F لندکروز وانت تک کابین', value: '485', company: 'toyota' },
  { id: '383', label: '3F لندکروز وانت دو کابین', value: '486', company: 'toyota' },
  { id: '384', label: 'وانت شوگا', value: '496', company: 'zamyad' },
  { id: '385', label: 'ون کاروان', value: '497', company: 'zamyad' },
  { id: '386', label: 'نيسان بنزینی', value: '498', company: 'zamyad' },
  { id: '387', label: 'نيسان ديزل', value: '499', company: 'zamyad' },
  { id: '388', label: 'زامیاد ریچ ', value: '500', company: 'zamyad' },
  { id: '389', label: 'زامیاد درکا', value: '501', company: 'zamyad' },
  { id: '390', label: 'زامیاد پادرا پلاس', value: '502', company: 'zamyad' },
  { id: '391', label: 'enranger G3', value: '507', company: 'huangHia' },
  { id: '392', label: 'سورنتو', value: '512', company: 'kia' },
  { id: '393', label: 'ريو', value: '513', company: 'kia' },
  { id: '394', label: 'سراتو', value: '514', company: 'kia' },
  { id: '395', label: 'اپتيما', value: '515', company: 'kia' },
  { id: '396', label: 'موهاوي', value: '516', company: 'kia' },
  { id: '397', label: 'اپيروس 2009', value: '517', company: 'kia' },
  { id: '398', label: 'پيکانتو2016-2012', value: '518', company: 'kia' },
  { id: '399', label: 'اسپورتج', value: '519', company: 'kia' },
  { id: '400', label: 'RIO sedan', value: '520', company: 'kia' },
  { id: '401', label: 'CADENZA', value: '521', company: 'kia' },
  { id: '402', label: 'RIO 2016 ', value: '522', company: 'kia' },
  { id: '403', label: 'پیکانتو', value: '523', company: 'kia' },
  { id: '404', label: 'کارنز ', value: '524', company: 'kia' },
  { id: '405', label: 'کارناوال ', value: '525', company: 'kia' },
  { id: '406', label: 'سراتو کوپ', value: '526', company: 'kia' },
  { id: '407', label: 'اپتیما هیبرید', value: '527', company: 'kia' },
  { id: '408', label: '2 جن', value: '536', company: 'poroton' },
  { id: '409', label: 'ویرا', value: '537', company: 'poroton' },
  { id: '410', label: 'ایمپین', value: '538', company: 'poroton' },
  { id: '411', label: 'سوناتا', value: '547', company: 'hyonda' },
  { id: '412', label: 'النترا', value: '548', company: 'hyonda' },
  { id: '413', label: 'سانتافه', value: '549', company: 'hyonda' },
  { id: '414', label: 'RB.2015 اکسنت', value: '550', company: 'hyonda' },
  { id: '415', label: 'آزرا', value: '551', company: 'hyonda' },
  { id: '416', label: 'ولستر', value: '552', company: 'hyonda' },
  { id: '417', label: '(XD) آوانته', value: '553', company: 'hyonda' },
  { id: '418', label: 'i20', value: '554', company: 'hyonda' },
  { id: '419', label: 'ix55 وراکروز', value: '555', company: 'hyonda' },
  { id: '420', label: 'توسان', value: '556', company: 'hyonda' },
  { id: '421', label: 'i30', value: '557', company: 'hyonda' },
  { id: '422', label: 'هيوندا کوپه', value: '558', company: 'hyonda' },
  { id: '423', label: 'ورنا', value: '559', company: 'hyonda' },
  { id: '424', label: 'جنسيس', value: '560', company: 'hyonda' },
  { id: '425', label: 'جنسيس کوپه', value: '561', company: 'hyonda' },
  { id: '426', label: 'i40', value: '562', company: 'hyonda' },
  { id: '427', label: 'i10', value: '563', company: 'hyonda' },
  { id: '428', label: 'i40 استیشن', value: '564', company: 'hyonda' },
  { id: '429', label: 'تراجت', value: '565', company: 'hyonda' },
  { id: '430', label: 'سوناتا هیبرید', value: '566', company: 'hyonda' },
  { id: '431', label: 'H350', value: '567', company: 'hyonda' },
  { id: '432', label: 'زانتيا', value: '578', company: 'citroen' },
  { id: '433', label: 'C5', value: '579', company: 'citroen' },
  { id: '434', label: 'C3', value: '580', company: 'citroen' },
  { id: '435', label: 'VAN Sprinter(GAS-314)', value: '585', company: 'benz' },
  { id: '436', label: 'VAN Sprinter(DES 315)', value: '586', company: 'benz' },
  { id: '437', label: 'A 170', value: '587', company: 'benz' },
  { id: '438', label: 'A 200', value: '588', company: 'benz' },
  { id: '439', label: 'B 170', value: '589', company: 'benz' },
  { id: '440', label: 'B 200', value: '590', company: 'benz' },
  { id: '441', label: 'B 200 TURBO', value: '591', company: 'benz' },
  { id: '442', label: 'C 180', value: '592', company: 'benz' },
  { id: '443', label: 'C 200', value: '593', company: 'benz' },
  { id: '444', label: 'C 230', value: '594', company: 'benz' },
  { id: '445', label: 'C 240 ', value: '595', company: 'benz' },
  { id: '446', label: 'C 280', value: '596', company: 'benz' },
  { id: '447', label: 'C 300', value: '597', company: 'benz' },
  { id: '448', label: 'C 350', value: '598', company: 'benz' },
  { id: '449', label: 'C COUPE', value: '599', company: 'benz' },
  { id: '450', label: 'CL 500', value: '600', company: 'benz' },
  { id: '451', label: 'CL 550', value: '601', company: 'benz' },
  { id: '452', label: 'CL 63', value: '602', company: 'benz' },
  { id: '453', label: 'CL 65', value: '603', company: 'benz' },
  { id: '454', label: 'CLA 200', value: '604', company: 'benz' },
  { id: '455', label: 'CLA 250 ', value: '605', company: 'benz' },
  { id: '456', label: 'CLA 45', value: '606', company: 'benz' },
  { id: '457', label: 'CLK 200 convertible', value: '607', company: 'benz' },
  { id: '458', label: 'CLK 280 convertible', value: '608', company: 'benz' },
  { id: '459', label: 'CLK 350 convertible', value: '609', company: 'benz' },
  { id: '460', label: 'CLK 200 COUPE', value: '610', company: 'benz' },
  { id: '461', label: 'CLK 280 COUPE', value: '611', company: 'benz' },
  { id: '462', label: 'CLK 320 COUPE', value: '612', company: 'benz' },
  { id: '463', label: 'CLK 350 COUPE', value: '613', company: 'benz' },
  { id: '464', label: 'CLS 350', value: '614', company: 'benz' },
  { id: '465', label: 'CLS 500', value: '615', company: 'benz' },
  { id: '466', label: 'CLS 550', value: '616', company: 'benz' },
  { id: '467', label: 'E 200', value: '617', company: 'benz' },
  { id: '468', label: 'E 230', value: '618', company: 'benz' },
  { id: '469', label: 'E 240 ', value: '619', company: 'benz' },
  { id: '470', label: 'E 250', value: '620', company: 'benz' },
  { id: '471', label: 'E 280', value: '621', company: 'benz' },
  { id: '472', label: 'E 300', value: '622', company: 'benz' },
  { id: '473', label: 'E 350 ', value: '623', company: 'benz' },
  { id: '474', label: 'E 200 SETARE IRAN', value: '624', company: 'benz' },
  { id: '475', label: 'E 280 SETARE IRAN', value: '625', company: 'benz' },
  { id: '476', label: 'E 350 SETARE IRAN', value: '626', company: 'benz' },
  { id: '477', label: 'E 200 convertible', value: '627', company: 'benz' },
  { id: '478', label: 'E 250 convertible', value: '628', company: 'benz' },
  { id: '479', label: 'E 350 convertible', value: '629', company: 'benz' },
  { id: '480', label: 'E 200 COUPE ', value: '630', company: 'benz' },
  { id: '481', label: 'E 250 COUPE', value: '631', company: 'benz' },
  { id: '482', label: 'E 350 COUPE', value: '632', company: 'benz' },
  { id: '483', label: 'G 350 ', value: '633', company: 'benz' },
  { id: '484', label: 'G 500', value: '634', company: 'benz' },
  { id: '485', label: 'G 63', value: '635', company: 'benz' },
  { id: '486', label: 'GL 500', value: '636', company: 'benz' },
  { id: '487', label: 'GLA 45 ', value: '637', company: 'benz' },
  { id: '488', label: 'GLK 280 ', value: '638', company: 'benz' },
  { id: '489', label: 'GLK 350', value: '639', company: 'benz' },
  { id: '490', label: 'ML 350 ', value: '640', company: 'benz' },
  { id: '491', label: 'ML 500', value: '641', company: 'benz' },
  { id: '492', label: 'S 280', value: '642', company: 'benz' },
  { id: '493', label: 'S 350', value: '643', company: 'benz' },
  { id: '494', label: 'S 500', value: '644', company: 'benz' },
  { id: '495', label: 'S 550', value: '645', company: 'benz' },
  { id: '496', label: 'SE 350', value: '646', company: 'benz' },
  { id: '497', label: 'SE 450 ', value: '647', company: 'benz' },
  { id: '498', label: 'SEL 450', value: '648', company: 'benz' },
  { id: '499', label: 'SL 350', value: '649', company: 'benz' },
  { id: '500', label: 'S 500', value: '650', company: 'benz' },
  { id: '501', label: 'SL 550', value: '651', company: 'benz' },
  { id: '502', label: 'SLC 450', value: '652', company: 'benz' },
  { id: '503', label: 'SLK 200', value: '653', company: 'benz' },
  { id: '504', label: 'SLK 280', value: '654', company: 'benz' },
  { id: '505', label: 'SLK 350', value: '655', company: 'benz' },
  { id: '506', label: 'GS', value: '669', company: 'mg' },
  { id: '507', label: 'MG 6', value: '670', company: 'mg' },
  { id: '508', label: 'MG GT(1.5L)', value: '671', company: 'mg' },
  { id: '509', label: 'MG 350', value: '672', company: 'mg' },
  { id: '510', label: 'MG 360 manual', value: '673', company: 'mg' },
  { id: '511', label: 'MG 360 at', value: '674', company: 'mg' },
  { id: '512', label: 'MG 360 at turbo', value: '675', company: 'mg' },
  { id: '513', label: 'MG RX5', value: '676', company: 'mg' },
  { id: '514', label: 'MG 3', value: '677', company: 'mg' },
  { id: '515', label: 'MG 6 GT', value: '678', company: 'mg' },
  { id: '516', label: 'S5 هایما', value: '686', company: 'haima' },
  { id: '517', label: 'S7 هایما', value: '687', company: 'haima' },
  { id: '518', label: 'S7 PLUS هایما', value: '688', company: 'haima' },
  { id: '519', label: 'S5 AT هایما', value: '689', company: 'haima' },
  { id: '520', label: '2000 ویتارا', value: '696', company: 'suzuki' },
  { id: '521', label: '2400 ویتارا', value: '697', company: 'suzuki' },
  { id: '522', label: 'کیزاشی', value: '698', company: 'suzuki' },
  { id: '523', label: 'ساندرو', value: '706', company: 'pars' },
  { id: '524', label: '90 تندر', value: '707', company: 'pars' },
  { id: '525', label: 'مگان', value: '708', company: 'pars' },
  { id: '526', label: 'ماکسيما', value: '709', company: 'pars' },
  { id: '527', label: 'نيسان پيکاپ جديد', value: '710', company: 'pars' },
  { id: '528', label: 'وانت ريچ', value: '711', company: 'pars' },
  { id: '529', label: 'رونيز', value: '712', company: 'pars' },
  { id: '530', label: 'پيکاپ', value: '713', company: 'pars' },
  { id: '531', label: 'سرانزا', value: '714', company: 'pars' },
  { id: '532', label: 'H320 برلیانس', value: '715', company: 'pars' },
  { id: '533', label: 'H230 برلیانس', value: '716', company: 'pars' },
  { id: '534', label: 'H330 برلیانس', value: '717', company: 'pars' },
  { id: '535', label: 'H220 برلیانس', value: '718', company: 'pars' },
  { id: '536', label: 'V5 برلیانس', value: '719', company: 'pars' },
  { id: '537', label: 'تینا', value: '720', company: 'pars' },
  { id: '538', label: '2015 کولیوس', value: '721', company: 'pars' },
  { id: '539', label: 'نیسان قشقایی', value: '722', company: 'pars' },
  { id: '540', label: 'CS35 چانگان', value: '729', company: 'changan' },
  { id: '541', label: 'چانگان ایدو', value: '730', company: 'changan' },
  { id: '542', label: '2000 اسپرو', value: '737', company: 'devo' },
  { id: '543', label: 'ريستر', value: '738', company: 'devo' },
  { id: '544', label: 'سيلو', value: '739', company: 'devo' },
  { id: '545', label: 'ماتیز', value: '740', company: 'devo' },
  { id: '546', label: '(SBRINA) سابرینا', value: '743', company: 'bayk' },
  { id: '547', label: 'x25', value: '744', company: 'bayk' },
  { id: '548', label: 'سنوا', value: '745', company: 'bayk' },
  { id: '549', label: 'تیگو 7 پرو', value: '748', company: 'phonix' },
  { id: '550', label: 'تیگو 8 پرو', value: '749', company: 'phonix' },
  { id: '551', label: 'آریزو 6 پرو', value: '750', company: 'phonix' },
  { id: '5511', label: 'FX 1.5L', value: '751', company: 'phonix' },
  { id: '55111', label: 'FX 1.6L', value: '752', company: 'phonix' },
  { id: '551111', label: 'مکس پرو تیگو 8', value: '753', company: 'phonix' },
  { id: '552', label: '511', value: '759', company: 'farda' },
  { id: '553', label: 'SX5', value: '760', company: 'farda' },
  { id: '554', label: 'SX6', value: '761', company: 'farda' },
  { id: '555', label: 'T5', value: '762', company: 'farda' },
  { id: '556', label: 'ایما', value: '769', company: 'lamary' },
  { id: '557', label: 'کوپا', value: '774', company: 'rigan' },
  { id: '558', label: 'T3', value: '779', company: 'biso' },
  { id: '559', label: 'T5', value: '780', company: 'biso' },
  { id: '560', label: 'F3', value: '783', company: 'byd' },
  { id: '561', label: 'S5', value: '784', company: 'byd' },
  { id: '562', label: 'S7', value: '785', company: 'byd' },
  { id: '563', label: 'X7', value: '789', company: 'damay' },
  { id: '564', label: 'BX5', value: '792', company: 'borgoard' },
  { id: '565', label: 'BX7', value: '793', company: 'borgoard' },
  { id: '566', label: 'X5', value: '796', company: 'hanteng' },
  { id: '567', label: 'X7', value: '797', company: 'hanteng' },
  { id: '568', label: 'پاتریوت', value: '800', company: 'uaz' },
  { id: '569', label: 'پیکاپ', value: '801', company: 'uaz' },
  { id: '570', label: 'H2', value: '804', company: 'hawal' },
  { id: '571', label: 'H6', value: '805', company: 'hawal' },
  { id: '572', label: 'H9', value: '806', company: 'hawal' },
  { id: '573', label: 'M4', value: '807', company: 'hawal' },
  { id: '574', label: 'G01', value: '813', company: 'swm' },
  { id: '575', label: 'G01F', value: '814', company: 'swm' },
  { id: '576', label: 'گل', value: '817', company: 'folex' },
  { id: '577', label: 'بیتل کوپه', value: '818', company: 'folex' },
  { id: '578', label: 'بیتل کروک', value: '819', company: 'folex' },
  { id: '579', label: 'گلف', value: '820', company: 'folex' },
  { id: '580', label: 'پاسات', value: '821', company: 'folex' },
  { id: '581', label: 'تیگوان', value: '822', company: 'folex' },
  { id: '582', label: 'ماکسیما دنده ', value: '827', company: 'nisan' },
  { id: '583', label: 'ماکسیما اتوماتیک', value: '828', company: 'nisan' },
  { id: '584', label: 'ایکس تریل', value: '829', company: 'nisan' },
  { id: '585', label: 'تی ینا', value: '830', company: 'nisan' },
  { id: '586', label: 'قشقایی', value: '831', company: 'nisan' },
  { id: '587', label: 'رونیز', value: '832', company: 'nisan' },
  { id: '588', label: 'مورانو ', value: '833', company: 'nisan' },
  { id: '589', label: 'جوک', value: '834', company: 'nisan' },
  { id: '590', label: 'لنسر 1600 سی سی دنده', value: '841', company: 'mitsubishi' },
  { id: '591', label: 'لنسر 1600 سی سی اتوماتیک', value: '842', company: 'mitsubishi' },
  { id: '592', label: 'لنسر 1800', value: '843', company: 'mitsubishi' },
  { id: '593', label: 'میراژ', value: '844', company: 'mitsubishi' },
  { id: '594', label: 'اتولندر هیبرید', value: '845', company: 'mitsubishi' },
  { id: '595', label: 'اتولندر ', value: '846', company: 'mitsubishi' },
  { id: '596', label: 'پاجرو 2 درب 6 سیلندر', value: '847', company: 'mitsubishi' },
  { id: '597', label: 'پاجرو 2 درب 4 سیلندر', value: '848', company: 'mitsubishi' },
  { id: '598', label: 'پاجرو 4 درب 4 سلیندر ', value: '849', company: 'mitsubishi' },
  { id: '599', label: 'پاجرو 4 درب 6 سلیندر ', value: '850', company: 'mitsubishi' },
  { id: '600', label: 'مگنا', value: '851', company: 'mitsubishi' },
  { id: '601', label: 'ASX', value: '852', company: 'mitsubishi' },
  { id: '602', label: 'گالانت ', value: '853', company: 'mitsubishi' },
]
// لیست شرکت های خودروسازی
const companyTypes: IsItem[] = [
  { id: '1', label: 'سایپا', value: '1' },
  { id: '2', label: 'ایرانخودرو ', value: '2' },
  { id: '3', label: 'بهمن', value: '3' },
  { id: '4', label: 'ام وی ام', value: '4' },
  { id: '5', label: 'چری', value: '5' },
  { id: '6', label: 'دانگ فنگ', value: '6' },
  { id: '7', label: 'بی ام و', value: '7' },
  { id: '8', label: 'جیلی', value: '8' },
  { id: '9', label: 'فاو', value: '9' },
  { id: '10', label: 'گریت وال', value: '10' },
  { id: '11', label: 'کرمان موتور', value: '11' },
  { id: '12', label: 'فوتون', value: '12' },
  { id: '13', label: 'رنو', value: '13' },
  { id: '14', label: 'پژو', value: '14' },
  { id: '15', label: 'آسنا', value: '15' },
  { id: '16', label: 'جک', value: '16' },
  { id: '17', label: 'مزدا', value: '17' },
  { id: '18', label: 'لیفان', value: '18' },
  { id: '19', label: 'سانگ یانگ', value: '19' },
  { id: '20', label: 'تویوتا', value: '20' },
  { id: '21', label: 'زامیاد', value: '21' },
  { id: '22', label: 'Huang Hia ', value: '22' },
  { id: '23', label: 'کیا', value: '23' },
  { id: '24', label: 'پروتون', value: '24' },
  { id: '25', label: 'هیوندا', value: '25' },
  { id: '26', label: 'سیتروئن', value: '26' },
  { id: '27', label: 'مرسدس بنز', value: '27' },
  { id: '28', label: 'ام جی ', value: '28' },
  { id: '29', label: 'هایما ', value: '29' },
  { id: '30', label: 'سوزوکی ', value: '30' },
  { id: '31', label: 'پارس خودرو ', value: '31' },
  { id: '32', label: 'چانگان  ', value: '32' },
  { id: '33', label: 'دوو  ', value: '33' },
  { id: '34', label: 'بایک  ', value: '34' },
  { id: '35', label: 'فونیکس  ', value: '35' },
  { id: '36', label: 'فردا  ', value: '36' },
  { id: '37', label: 'لاماری  ', value: '37' },
  { id: '38', label: 'ریگان  ', value: '38' },
  { id: '39', label: 'بیسو  ', value: '39' },
  { id: '40', label: 'بی وای دی  ', value: '40' },
  { id: '41', label: 'دامای  ', value: '41' },
  { id: '42', label: 'بورگوارد  ', value: '42' },
  { id: '43', label: 'هن تنگ  ', value: '43' },
  { id: '44', label: 'یوآز  ', value: '44' },
  { id: '45', label: 'هاوال  ', value: '45' },
  { id: '46', label: 'اس دبلیو ام  ', value: '46' },
  { id: '47', label: 'فولکس  ', value: '47' },
  { id: '48', label: 'نیسان  ', value: '48' },
  { id: '49', label: 'میتسوبیشی  ', value: '49' },
]

const markerGreen = L.icon({
  iconUrl:
    'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
})
const markerRed = L.icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
})
const markerBlue = L.icon({
  iconUrl:
    'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
})

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export interface DialogTitleProps {
  id: string
  children?: React.ReactNode
  onClose: () => void
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontSize: '15px' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}
interface FormValues {
  date: string
}

const initialValues: FormValues = {
  date: '',
}

const validationSchema = Yup.object().shape({
  date: Yup.string().required('ورود تاریخ الزامی است').label('تاریخ'),
})
interface FormValues1 {
  company: string
  car: string
}

const initialValues1: FormValues1 = {
  company: companyTypes[0].value,
  car: modelTypes[0].value,
}

const validationSchema1 = Yup.object().shape({
  company: Yup.string().required('انتخاب شرکت سازنده الزامی است').label('company'),
  car: Yup.string().required('انتخاب نوع خودرو الزامی است').label('car'),
})
interface FormValues2 {
  imei: string
}

const initialValues2: FormValues2 = {
  imei: '',
}

const validationSchema2 = Yup.object().shape({
  imei: Yup.string()
    .required('ورود شماره شناسایی دستگاه الزامی است')
    .label('imei')
    .max(15, 'حداکثر تا 15 رقم مجاز است')
    .min(13, 'حداقل تا 13 رقم مجاز است')
    .matches(/^[0-9]*$/, 'لطفا شماره شناسایی دستگاه را به درستی وارد نمایید'),
})
interface FormValues3 {
  phone: string
}

const initialValues3: FormValues3 = {
  phone: '',
}

const validationSchema3 = Yup.object().shape({
  phone: Yup.string()
    .required('ورود شماره همراه الزامی است')
    .label('phone')
    .max(11, 'حداکثر تا 11 رقم مجاز است')
    .min(11, 'حداقل تا 11 رقم مجاز است')
    .matches(/^[0-9]*$/, 'لطفا شماره همراه را به درستی وارد نمایید'),
})
interface FormValues4 {
  nameLname: string
}

const initialValues4: FormValues4 = {
  nameLname: '',
}

const validationSchema4 = Yup.object().shape({
  nameLname: Yup.string().required('ورود نام یا نام خانوادگی الزامی است').label('nameLname'),
})
interface FormValues5 {
  startdate: string
  enddate: string
}

const initialValues5: FormValues5 = {
  startdate: '',
  enddate: '',
}

const validationSchema5 = Yup.object().shape({
  startdate: Yup.string().required('انتخاب تاریخ شروع الزامی است').label('startdate'),
  enddate: Yup.string().required('اتخاب تاریخ پایان الزامی است').label('enddate'),
})
interface FormValues6 {
  startdate: string
  enddate: string
}

const initialValues6: FormValues6 = {
  startdate: '',
  enddate: '',
}

const validationSchema6 = Yup.object().shape({
  startdate: Yup.string().required('انتخاب تاریخ شروع الزامی است').label('startdate'),
  enddate: Yup.string().required('اتخاب تاریخ پایان الزامی است').label('enddate'),
})
interface IsCar {
  id: string
  name: string
  model: string
  status: string
  number: string
}
interface FormValues7 {
  startdate: string
  enddate: string
}

const initialValues7: FormValues7 = {
  startdate: '',
  enddate: '',
}

const validationSchema7 = Yup.object().shape({
  startdate: Yup.string().required('انتخاب تاریخ شروع الزامی است').label('startdate'),
  enddate: Yup.string().required('اتخاب تاریخ پایان الزامی است').label('enddate'),
})
interface IsCar {
  id: string
  name: string
  model: string
  status: string
  number: string
}

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

const Search: FC = () => {
  // تابع فیلتر خودروها براساس شرکت سازنده برای نمایش در لیست باکس

  const getCarModels = (companyId: string) => {
    switch (companyId) {
      case '1':
        return modelTypes.filter((p) => p.company === 'saipa')
      case '2':
        return modelTypes.filter((p) => p.company === 'iran-Khodro')
      case '3':
        return modelTypes.filter((p) => p.company === 'bahman')
      case '4':
        return modelTypes.filter((p) => p.company === 'mvm')
      case '5':
        return modelTypes.filter((p) => p.company === 'chery')
      case '6':
        return modelTypes.filter((p) => p.company === 'dongFang')
      case '7':
        return modelTypes.filter((p) => p.company === 'bmw')
      case '8':
        return modelTypes.filter((p) => p.company === 'jili')
      case '9':
        return modelTypes.filter((p) => p.company === 'faw')
      case '10':
        return modelTypes.filter((p) => p.company === 'gratewall')
      case '11':
        return modelTypes.filter((p) => p.company === 'kerman')
      case '12':
        return modelTypes.filter((p) => p.company === 'foton')
      case '13':
        return modelTypes.filter((p) => p.company === 'reno')
      case '14':
        return modelTypes.filter((p) => p.company === 'pegout')
      case '15':
        return modelTypes.filter((p) => p.company === 'asna')
      case '16':
        return modelTypes.filter((p) => p.company === 'jac')
      case '17':
        return modelTypes.filter((p) => p.company === 'mazda')
      case '18':
        return modelTypes.filter((p) => p.company === 'lifan')
      case '19':
        return modelTypes.filter((p) => p.company === 'songyong')
      case '20':
        return modelTypes.filter((p) => p.company === 'toyota')
      case '21':
        return modelTypes.filter((p) => p.company === 'zamyad')
      case '22':
        return modelTypes.filter((p) => p.company === 'huangHia')
      case '23':
        return modelTypes.filter((p) => p.company === 'kia')
      case '24':
        return modelTypes.filter((p) => p.company === 'poroton')
      case '25':
        return modelTypes.filter((p) => p.company === 'hyonda')
      case '26':
        return modelTypes.filter((p) => p.company === 'citroen')
      case '27':
        return modelTypes.filter((p) => p.company === 'benz')
      case '28':
        return modelTypes.filter((p) => p.company === 'mg')
      case '29':
        return modelTypes.filter((p) => p.company === 'haima')
      case '30':
        return modelTypes.filter((p) => p.company === 'suzuki')
      case '31':
        return modelTypes.filter((p) => p.company === 'pars')
      case '32':
        return modelTypes.filter((p) => p.company === 'changan')
      case '33':
        return modelTypes.filter((p) => p.company === 'devo')
      case '34':
        return modelTypes.filter((p) => p.company === 'bayk')
      case '35':
        return modelTypes.filter((p) => p.company === 'phonix')
      case '36':
        return modelTypes.filter((p) => p.company === 'farda')
      case '37':
        return modelTypes.filter((p) => p.company === 'lamary')
      case '38':
        return modelTypes.filter((p) => p.company === 'rigan')
      case '39':
        return modelTypes.filter((p) => p.company === 'biso')
      case '40':
        return modelTypes.filter((p) => p.company === 'byd')
      case '41':
        return modelTypes.filter((p) => p.company === 'damay')
      case '42':
        return modelTypes.filter((p) => p.company === 'borgoard')
      case '43':
        return modelTypes.filter((p) => p.company === 'hanteng')
      case '44':
        return modelTypes.filter((p) => p.company === 'uaz')
      case '45':
        return modelTypes.filter((p) => p.company === 'hawal')
      case '46':
        return modelTypes.filter((p) => p.company === 'swm')
      case '47':
        return modelTypes.filter((p) => p.company === 'folex')
      case '48':
        return modelTypes.filter((p) => p.company === 'nisan')
      case '49':
        return modelTypes.filter((p) => p.company === 'mitsubishi')

      default:
        return modelTypes
    }
  }
  // تابع فیلتر خودروها براساس شرکت سازنده برای نمایش در لیست باکس

  const getCarCopmany = (companyId: string) => {
    switch (companyId) {
      case '1':
        return 'سایپا'
      case '2':
        return 'ایرانخودرو'
      case '3':
        return 'بهمن'
      case '4':
        return 'ام وی ام'
      case '5':
        return 'چری'
      case '6':
        return 'دانگ فنگ'
      case '7':
        return 'بی ام و'
      case '8':
        return 'جیلی'
      case '9':
        return 'فاو'
      case '10':
        return 'گریت وال'
      case '11':
        return 'کرمان موتور'
      case '12':
        return 'فوتون'
      case '13':
        return 'رنو'
      case '14':
        return 'پژو'
      case '15':
        return 'آسنا'
      case '16':
        return 'جک'
      case '17':
        return 'مزدا'
      case '18':
        return 'لیفان'
      case '19':
        return 'سانگ یانگ'
      case '20':
        return 'تویوتا'
      case '21':
        return 'زامیاد'
      case '22':
        return 'Huang Hia'
      case '23':
        return 'کیا'
      case '24':
        return 'پروتون'
      case '25':
        return 'هیوندا'
      case '26':
        return 'سیتروئن'
      case '27':
        return 'مرسدس بنز'
      case '28':
        return 'ام جی'
      case '29':
        return 'هایما'
      case '30':
        return 'سوزوکی'
      case '31':
        return 'پارس خودرو'
      case '32':
        return 'چانگان'
      case '33':
        return 'دوو'
      case '34':
        return 'بایک'
      case '35':
        return 'فونیکس'
      case '36':
        return 'فردا'
      case '37':
        return 'لاماری'
      case '38':
        return 'ریگان'
      case '39':
        return 'بیسو'
      case '40':
        return 'بی وای دی'
      case '41':
        return 'دامای'
      case '42':
        return 'بورگوارد'
      case '43':
        return 'هن تنگ'
      case '44':
        return 'یوآز'
      case '45':
        return 'هاوال'
      case '46':
        return 'اس دبلیو ام'
      case '47':
        return 'فولکس'
      case '48':
        return 'نیسان'
      case '49':
        return 'میتسوبیشی'

      default:
        return 'ثبت نشده'
    }
  }
  // States
  const refreshToken1 = localStorage.getItem('refresh_token')
  const loading = useSelector(getLoading)
  const paginatedList = useSelector(getPaginatedList)
  const devicePaginated = useSelector(getDevicePaginated)
  const searchPositionDevice = useSelector(getSearchPosition)
  const [resultSearchPositionDevice, setResultSearchPositionDevice] = useState(searchPositionDevice)
  const { t } = useTranslation()
  const [text, setText] = useState('')
  const list = useSelector(getDeviceList)
  const editRef = React.useRef<any>()
  const [cars, setCars] = useState(list)
  const [statusOnline, setStatusOnline] = useState(false)
  const [statusOffnline, setStatusOffnline] = useState(false)
  const [date1, setDate1] = useState<string>()
  const [selectRange, setSelectRange] = useState(false)
  const [filter, setFilter] = useState<string>('name')
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [isPending, startTransition] = useTransition()
  const [drafts, setDrafts] = React.useState<any>([])
  const [drawRectangle, setDrawRectangle] = useState(false)
  const refFeatureGroup = React.useRef<any>()
  const navigate = useNavigate()

  useEffect(() => {
    setResultSearchPositionDevice(searchPositionDevice)
  }, [searchPositionDevice])
  // Selectors
  const onMountedRect = (e: any) => {
    editRef.current = e
  }
  const onShapeDrawn = (e: L.DrawEvents.Created) => {
    setDrafts((drafts: any) => [...drafts, e])
  }
  const userInfo = useSelector(getIsUserInfo)
  const refreshTokenFlag = useSelector(getRefreshToken)
  const deviceSearch = useSelector(getdeviceSearch)
  const { enqueueSnackbar } = useSnackbar()
  // const id = userInfo.sub

  const open = Boolean(anchorEl)
  const dispatch = useDispatch<Dispatch<any>>()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleCancelFilter = () => {
    setFlagFilter(false)
    setSearchList(paginatedList)
    setTitleSearch(t('screens.CarsScreen.naji'))
    setShowPaginated(true)
  }

  const handleClickLastOnline = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setFilter(newValue)
    setSelectRange(false)
    setAnchorEl(null)
    setOpen2(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickOnline = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setFilter(newValue)
    setAnchorEl(null)
    setSelectRange(false)
    dispatch(searchPosition({ searchDeviceType: '2' }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_online'))
    setFlagFilter(true)
    setShowPaginated(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickOffline = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setFilter(newValue)
    setAnchorEl(null)
    setSelectRange(false)
    dispatch(searchPosition({ searchDeviceType: '3' }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_ofline'))
    setFlagFilter(true)
    setShowPaginated(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickModel = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setFilter(newValue)
    setSelectRange(false)
    setAnchorEl(null)
    setOpen3(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickIMEI = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setFilter(newValue)
    setSelectRange(false)
    setAnchorEl(null)
    setOpen4(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickPhoneNumber = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    setFilter(newValue)
    setAnchorEl(null)
    setSelectRange(false)
    setOpen5(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickName = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setFilter(newValue)
    setAnchorEl(null)
    setOpen6(true)
    setSelectRange(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickGeoFenceActivity = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    setFilter(newValue)
    setSelectRange(false)
    setAnchorEl(null)
    setOpen8(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickTroubleCode = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    setFilter(newValue)
    setSelectRange(false)
    setAnchorEl(null)
    setOpen7(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickSpeedLimitation = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    setFilter(newValue)
    setSelectRange(false)
    setAnchorEl(null)
    setOpen9(true)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickInternetDisconnected = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    setFilter(newValue)
    setAnchorEl(null)
    setSelectRange(false)
    dispatch(searchPosition({ searchDeviceType: '11' }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_internet'))
    setFlagFilter(true)
    setShowPaginated(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickDeviceDisconnected = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    setFilter(newValue)
    setAnchorEl(null)
    setSelectRange(false)
    dispatch(searchPosition({ searchDeviceType: '12' }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_deActive'))
    setFlagFilter(true)
    setShowPaginated(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
  }
  const handleClickSelectRenge = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }
    setFilter(newValue)
    setAnchorEl(null)
    setSelectRange(true)
    dispatch(resetLastPositionSearch)

    // dispatch(searchPosition({ searchDeviceType: '13' }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_SelectRange'))
    setFlagFilter(true)
    setShowPaginated(false)
  }
  const [page, setPage] = React.useState(0)

  const handlelogut = () => {
    localStorage.removeItem('token')
    dispatch(setLogged)

    // navigate('/', { replace: true })
  }
  const responsiveMuiGird = {
    '&.MuiGrid-root.MuiGrid-container': {
      maxHeight: ' calc(95vh - 178px)',
      overflow: 'auto',

      // color: { xs: 'yellow', sm: 'blue' },
    },
  }
  const [open2, setOpen2] = useState(false)
  const [open3, setOpen3] = useState(false)
  const [open4, setOpen4] = useState(false)
  const [open5, setOpen5] = useState(false)
  const [open6, setOpen6] = useState(false)
  const [open7, setOpen7] = useState(false)
  const [open8, setOpen8] = useState(false)
  const [open9, setOpen9] = useState(false)
  const [open10, setOpen10] = useState(false)
  const [showPaginated, setShowPaginated] = useState(true)
  const handleSubmit = (values: any) => {
    dispatch(searchPosition({ searchDeviceType: '1', dateTime: values.date }))
    setTitleSearch(t('screens.CarsScreen.last_on_time'))
    setFlagFilter(true)
    setOpen2(false)
    setShowPaginated(false)
  }
  const handleSubmitModel = (values: any) => {
    dispatch(searchPosition({ searchDeviceType: '4', model: values.car }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_type'))
    setFlagFilter(true)
    setOpen3(false)
    setShowPaginated(false)
  }
  const handleSubmitimei = (values: any) => {
    dispatch(searchPosition({ searchDeviceType: '5', imei: values.imei }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_imei'))
    setFlagFilter(true)
    setOpen4(false)
    setShowPaginated(false)
  }
  const handleSubmitphone = (values: any) => {
    dispatch(searchPosition({ searchDeviceType: '6', phoneNumber: values.phone }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_mobile'))
    setFlagFilter(true)
    setOpen5(false)
    setShowPaginated(false)
  }
  const handleSubmitnameLname = (values: any) => {
    dispatch(searchPosition({ searchDeviceType: '7', name: values.nameLname }))
    setTitleSearch(t('screens.CarsScreen.Show_cars_nameLname'))
    setFlagFilter(true)
    setOpen6(false)
    setShowPaginated(false)
  }
  const handleSubmitTroubleCode = (values: any) => {
    dispatch(
      searchPosition({
        searchDeviceType: '8',
        startDateTime: values.startdate,
        endDateTime: values.enddate,
      }),
    )
    setTitleSearch(t('screens.CarsScreen.Show_cars_errors'))
    setFlagFilter(true)
    setOpen7(false)
    setShowPaginated(false)
  }
  const handleSubmitGeoFenceActivity = (values: any) => {
    dispatch(
      searchPosition({
        searchDeviceType: '9',
        startDateTime: values.startdate,
        endDateTime: values.enddate,
      }),
    )
    setTitleSearch(t('screens.CarsScreen.Show_cars_Geofence'))
    setFlagFilter(true)
    setOpen8(false)
    setShowPaginated(false)
  }
  const handleSubmitSpeedLimitation = (values: any) => {
    dispatch(
      searchPosition({
        searchDeviceType: '10',
        startDateTime: values.startdate,
        endDateTime: values.enddate,
      }),
    )
    setTitleSearch(t('screens.CarsScreen.Show_cars_speed'))
    setFlagFilter(true)
    setOpen9(false)
    setShowPaginated(false)
  }
  const handleClose2 = () => {
    setOpen2(false)
  }
  const handleClose3 = () => {
    setOpen3(false)
  }
  const handleClose4 = () => {
    setOpen4(false)
  }
  const handleClose5 = () => {
    setOpen5(false)
  }
  const handleClose6 = () => {
    setOpen6(false)
  }
  const handleClose7 = () => {
    setOpen7(false)
  }
  const handleClose8 = () => {
    setOpen8(false)
  }
  const handleClose9 = () => {
    setOpen9(false)
  }

  useEffect(() => {
    if (drawRectangle) {
      setOpen10(true)
    }
  }, [drawRectangle])

  const handleSelectRange = () => {
    editRef.current._toolbars.draw._modes.rectangle.handler.enable()
  }

  useEffect(() => {
    return () => {
      dispatch(resetLastPositionSearch)
    }
  }, [])
  useEffect(() => {
    setSearchList(paginatedList)
  }, [paginatedList])
  useEffect(() => {
    if (deviceSearch.length === 0) return
    setSearchList(deviceSearch)
  }, [deviceSearch])
  const [titleSearch, setTitleSearch] = useState<any>(t('screens.CarsScreen.naji'))
  const [searchList, setSearchList] = useState(paginatedList)
  const [flagFilter, setFlagFilter] = useState(false)

  // eslint-disable-next-line no-lone-blocks
  const numberPlateMizan = (pelak1: string) => {
    if (pelak1 === undefined) return 'ثبت نشده'
    const pelak = _.split(pelak1, '-', 4)
    return pelak[3] + 'ایران' + pelak[2] + pelak[1] + pelak[0]
  }
  const ExcelExportData = resultSearchPositionDevice.map((p: any, index: number) => ({
    ردیف: index + 1,
    'شرکت سازنده': getCarCopmany(p.item2.properties.company),
    'نوع خودرو':
      p.item2.properties.modelName === undefined ? 'ثبت نشده' : p.item2.properties.modelName,
    'شماره پلاک': numberPlateMizan(p.item2.properties.numberPlate),
    'نام و نام خانوادگی':
      p.item2.properties.nameLname === undefined ? 'ثبت نشده' : p.item2.properties.nameLname,
    'شماره شناسایی دستگاه': p.item2.id,
    'شماره سیم کارت': p.item2.simNo === '' ? 'ثبت نشده' : p.item2.simNo,
    'میزان محدودیت سرعت': p.item2.overSpeedLimitation,
  }))
  const shamsiToday = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)

    return (
      date.weekDay.name + '  ' + date.format('DD - MMMM - YYYY') + '  ' + date.format('HH:mm:ss')
    )
  }

  const [alignment, setAlignment] = React.useState<string>('')
  // نمایش زمان های گذشته با تاگل 48و24و12و6و2 ساعت قبل

  const handleChangeToggle = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    setAlignment(newAlignment)
  }
  const handleYesterdayDay = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.subtract(1, 'day')
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(1, 'day')

    dispatch(searchPosition({ searchDeviceType: '1', dateTime: startDate1 }))
    setTitleSearch(t('screens.CarsScreen.24hourseAgo'))
    setFlagFilter(true)
    setOpen2(false)
    setShowPaginated(false)
  }
  const handle12hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(15, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')

    date.add(12, 'hour')
    // date.add(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(searchPosition({ searchDeviceType: '1', dateTime: startDate1 }))
    setTitleSearch(t('screens.CarsScreen.12hourseAgo'))
    setFlagFilter(true)
    setOpen2(false)
    setShowPaginated(false)
  }
  const handle48hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.subtract(2, 'day')
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(2, 'day')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(searchPosition({ searchDeviceType: '1', dateTime: startDate1 }))
    setTitleSearch(t('screens.CarsScreen.48hourseAgo'))
    setFlagFilter(true)
    setOpen2(false)
    setShowPaginated(false)
  }
  const handle6hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(9, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')

    date.add(6, 'hour')
    // date.add(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(searchPosition({ searchDeviceType: '1', dateTime: startDate1 }))
    setTitleSearch(t('screens.CarsScreen.6hourseAgo'))
    setFlagFilter(true)
    setOpen2(false)
    setShowPaginated(false)
  }
  const handle2hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(5, 'hour')
    date.subtract(30, 'minute')
    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(2, 'hour')
    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    // date.add(30, 'minute')

    dispatch(searchPosition({ searchDeviceType: '1', dateTime: startDate1 }))
    setTitleSearch(t('screens.CarsScreen.2hourseAgo'))
    setFlagFilter(true)
    setOpen2(false)
    setShowPaginated(false)
  }
  useEffect(() => {
    if (drafts.length !== 0 && drafts[drafts.length - 1].layerType === 'rectangle') {
      setDrawRectangle(true)
    }
  }, [drafts])

  const handleSubmitRectangle = (values: any) => {
    setOpen10(false)
    setDrawRectangle(false)

    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      dispatch(
        searchPosition({
          searchDeviceType: '13',
          UpperLeftLatitude: layer._latlngs[0][0].lat,
          UpperLeftLongitude: layer._latlngs[0][0].lng,
          LowerRightLatitude: layer._latlngs[0][2].lat,
          LowerRightLongitude: layer._latlngs[0][2].lng,
        }),
      )
      setSelectRange(false)
    }
  }
  const handleCancelRectangle = (e: any) => {
    setOpen10(false)
    setDrawRectangle(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }

    // }
  }

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value)
  }

  useEffect(() => {
    if (filter === 'Online') {
      setStatusOnline(true)
      setStatusOffnline(false)
    } else if (filter === 'Offline') {
      setStatusOffnline(true)
      setStatusOnline(false)
    } else {
      setStatusOnline(false)
      setStatusOffnline(false)
    }
  }, [searchPositionDevice])

  return (
    <Box>
      <Box
        position='relative'
        sx={{
          width: '100vw',
          height: '90vh',
          '& .leaflet-right': { display: 'none' },
          '& .leaflet-popup-content': { fontFamily: 'Vazir' },
          '& .leaflet-container': { fontFamily: 'Vazir', fontSize: 15 },
          '& .leaflet-interactive': { outline: 'none' },
        }}
      >
        <MapContainer
          center={[35.7219, 51.3347]}
          scrollWheelZoom={false}
          style={{ minHeight: '100%', minWidth: '100%' }}
          zoom={7}
        >
          <Box sx={{ '& path.leaflet-interactive:focus': { outline: 'none' } }}>
            <FeatureGroup ref={refFeatureGroup}>
              <EditControl
                draw={{
                  rectangle: { shapeOptions: { color: 'red' } },
                  circle: { shapeOptions: { color: 'red' } },
                  circlemarker: false,
                  polyline: false,
                  marker: false,
                  polygon: { showLength: true, shapeOptions: { color: 'red' } },
                }}
                onCreated={onShapeDrawn}
                onMounted={onMountedRect}
                position='topright'
                // edit={{ edit: false}}
              />
            </FeatureGroup>
          </Box>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          />
          {searchPositionDevice?.length !== 0 &&
            searchPositionDevice !== undefined &&
            searchPositionDevice?.map((PositionDevice: any) => (
              <Marker
                icon={statusOnline ? markerGreen : statusOffnline ? markerRed : markerBlue}
                key={PositionDevice?.item1?.deviceId}
                position={[
                  PositionDevice?.item1?.gps?.latitude ? PositionDevice?.item1?.gps?.latitude : '',
                  PositionDevice?.item1?.gps?.longitude
                    ? PositionDevice?.item1?.gps?.longitude
                    : '',
                ]}
              >
                <Popup>
                  <CarItem1
                    car={PositionDevice?.item2?.properties}
                    id={PositionDevice?.item1?.deviceId}
                    onStatus={PositionDevice?.item2?.deviceStatus}
                  />
                </Popup>
              </Marker>
            ))}
        </MapContainer>
        <Box m={1} position={'absolute'} right={0} top={0}>
          <Fab aria-label='edit' color='error' onClick={handleClick} size='small'>
            <FilterAltRoundedIcon />
          </Fab>
        </Box>
        {searchPositionDevice?.length !== 0 && (
          <Box bottom={0} left={0} m={1} position={'absolute'}>
            <Fab
              aria-label='edit'
              color='error'
              onClick={() => enqueueSnackbar(titleSearch, { variant: 'info' })}
              size='large'
              sx={{ mr: 1 }}
              title={titleSearch}
            >
              {searchPositionDevice?.length !== 0 &&
                searchPositionDevice !== undefined &&
                searchPositionDevice?.filter(
                  (PositionDevice: any) => PositionDevice?.item1?.gps !== null,
                ).length}
              <br />
              تعداد
            </Fab>
            <ExcelJsExport date={shamsiToday()} excelData={ExcelExportData} titlle={titleSearch} />
          </Box>
        )}
        {selectRange && (
          <Box bottom={0} m={1} position={'absolute'} right={0}>
            <Fab onClick={handleSelectRange} sx={{ backgroundColor: 'red' }}>
              <RectangleRoundedIcon />
            </Fab>
          </Box>
        )}
      </Box>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        id='basic-menu'
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        onClose={handleClose}
        open={open}
        sx={{ direction: 'rtl', '& .MuiPopover-paper': { height: '400px' } }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={(e) => handleClickLastOnline(e, 'LastOnline')}>
          <ListItemIcon>{filter === 'LastOnline' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.last_on_time')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickOnline(e, 'Online')}>
          <ListItemIcon>{filter === 'Online' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_online')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickOffline(e, 'Offline')}>
          <ListItemIcon>{filter === 'Offline' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_ofline')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickModel(e, 'Model')}>
          <ListItemIcon>{filter === 'Model' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText> {t('screens.CarsScreen.Show_cars_type')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickIMEI(e, 'IMEI')}>
          <ListItemIcon>{filter === 'IMEI' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_imei')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickPhoneNumber(e, 'PhoneNumber')}>
          <ListItemIcon>{filter === 'PhoneNumber' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_mobile')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickName(e, 'Name')}>
          <ListItemIcon>{filter === 'Name' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_nameLname')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickTroubleCode(e, 'TroubleCode')}>
          <ListItemIcon>{filter === 'TroubleCode' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_errors')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickGeoFenceActivity(e, 'GeoFenceActivity')}>
          <ListItemIcon>{filter === 'GeoFenceActivity' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_Geofence')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickSpeedLimitation(e, 'SpeedLimitation')}>
          <ListItemIcon>{filter === 'SpeedLimitation' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_speed')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickInternetDisconnected(e, 'InternetDisconnected')}>
          <ListItemIcon>{filter === 'InternetDisconnected' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_internet')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickDeviceDisconnected(e, 'DeviceDisconnected')}>
          <ListItemIcon>{filter === 'DeviceDisconnected' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_deActive')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => handleClickSelectRenge(e, 'SelectRenge')}>
          <ListItemIcon>{filter === 'SelectRenge' && <DoneRoundedIcon />}</ListItemIcon>
          <ListItemText>{t('screens.CarsScreen.Show_cars_SelectRange')}</ListItemText>
        </MenuItem>
      </Menu>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <div className='spinner'></div>
      </Backdrop>
      <div>
        <Dialog
          aria-describedby='alert-dialog-description'
          aria-labelledby='alert-dialog-title'
          onClose={handleCancelRectangle}
          open={open10}
        >
          <DialogTitle id='alert-dialog-title'>{'آیا شکل ترسیمی مورد تایید است؟'}</DialogTitle>
          <DialogContent>
            <Box display='flex' flexDirection='column' sx={{ direction: 'rtl' }}>
              <Button onClick={handleSubmitRectangle} sx={{ mt: 1 }} variant='contained'>
                {'ثبت'}
              </Button>
              <Button onClick={handleCancelRectangle} sx={{ mt: 1 }}>
                {'لغو'}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open2}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose2}>
            {t('screens.CarsScreen.last_on_time')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmit}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })

                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('date', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[
                            <TimePicker
                              key={'extenssion'}
                              position='bottom'
                              style={{ fontFamily: 'Vazir' }}
                            />,
                          ]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={10000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.date}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
            <Box sx={{ mt: 1, direction: 'ltr', display: 'flex', justifyContent: 'center' }}>
              <ToggleButtonGroup
                aria-label='Platform'
                color='primary'
                exclusive
                onChange={handleChangeToggle}
                sx={{ maxHeight: 90, background: 'linear-gradient(rgb(247 252 252), #818181)' }}
                value={alignment}
              >
                <ToggleButton onClick={handle2hourAgo} value='2hourAgo'>
                  <img src={iranflag2} width='30px' />
                </ToggleButton>
                <ToggleButton onClick={handle6hourAgo} value='6hourAgo'>
                  <img src={iranflag6} width='30px' />
                </ToggleButton>
                <ToggleButton onClick={handle12hourAgo} value='12hourAgo'>
                  <img src={iranflag12} width='30px' />
                </ToggleButton>
                <ToggleButton onClick={handleYesterdayDay} value='yesterday'>
                  <img src={iranflag24} width='30px' />
                </ToggleButton>
                <ToggleButton onClick={handle48hourAgo} value='48hourAgo'>
                  <img src={iranflag48} width='30px' />
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </DialogContent>
        </BootstrapDialog>
      </div>

      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open3}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose3}>
            {t('screens.CarsScreen.Show_cars_type')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues1}
              onSubmit={handleSubmitModel}
              validationSchema={validationSchema1}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitModel}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.cars_company')}:
                    </InputLabel>
                    <Select
                      fullWidth
                      items={companyTypes}
                      name='company'
                      onBlur={handleBlur}
                      onChange={(e: any) => {
                        handleChange(e)
                        setFieldValue('car', getCarModels(e.target.value)[0].value)
                      }}
                      value={values.company}
                    />
                    <div style={{ color: 'red', fontSize: '10px' }}>{errors.company}</div>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.cars')}:
                    </InputLabel>
                    <Select
                      fullWidth
                      items={getCarModels(values.company)}
                      name='car'
                      onBlur={handleBlur}
                      onChange={(e: any) => {
                        handleChange(e)
                      }}
                      value={values.car}
                    />
                    <div style={{ color: 'red', fontSize: '10px' }}>{errors.car}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open4}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose4}>
            {t('screens.CarsScreen.Show_cars_imei')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues2}
              onSubmit={handleSubmitimei}
              validationSchema={validationSchema2}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitimei}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.device_imei')}:
                    </InputLabel>

                    <Input
                      autoComplete='off'
                      fullWidth
                      name='imei'
                      onBlur={handleBlur}
                      onChange={(e: any) => handleChange(e)}
                      value={values.imei}
                    />
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.imei}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open5}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose5}>
            {t('screens.CarsScreen.Show_cars_mobile')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues3}
              onSubmit={handleSubmitphone}
              validationSchema={validationSchema3}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitphone}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.mobile')}:
                    </InputLabel>

                    <Input
                      autoComplete='off'
                      fullWidth
                      name='phone'
                      onBlur={handleBlur}
                      onChange={(e: any) => handleChange(e)}
                      value={values.phone}
                    />
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.phone}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      ارسال
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open6}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose6}>
            {t('screens.CarsScreen.Show_cars_nameLname')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues4}
              onSubmit={handleSubmitnameLname}
              validationSchema={validationSchema4}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitnameLname}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.nameLname')}:
                    </InputLabel>

                    <Input
                      autoComplete='off'
                      fullWidth
                      name='nameLname'
                      onBlur={handleBlur}
                      onChange={(e: any) => handleChange(e)}
                      value={values.nameLname}
                    />
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.nameLname}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>

      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open7}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose7}>
            {t('screens.CarsScreen.Show_cars_errors')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues5}
              onSubmit={handleSubmitTroubleCode}
              validationSchema={validationSchema5}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitTroubleCode}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_start_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })
                            const a = date.format('YYYY-MM-DD HH:mm')
                            setDate1(a)
                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('startdate', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[<TimePicker key={'extenssion'} position='bottom' />]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={100000000000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.startdate}</div>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_end_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          minDate={date1}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })

                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('enddate', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[
                            <TimePicker
                              key={'extenssion'}
                              position='bottom'
                              style={{ fontFamily: 'Vazir' }}
                            />,
                          ]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={10000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.enddate}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open8}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose8}>
            {t('screens.CarsScreen.Show_cars_Geofence')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues6}
              onSubmit={handleSubmitGeoFenceActivity}
              validationSchema={validationSchema6}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitGeoFenceActivity}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_start_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })
                            const a = date.format('YYYY-MM-DD HH:mm')
                            setDate1(a)
                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('startdate', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[<TimePicker key={'extenssion'} position='bottom' />]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={100000000000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.startdate}</div>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_end_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          minDate={date1}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })

                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('enddate', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[
                            <TimePicker
                              key={'extenssion'}
                              position='bottom'
                              style={{ fontFamily: 'Vazir' }}
                            />,
                          ]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={10000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.enddate}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <div>
        <BootstrapDialog
          aria-labelledby='customized-dialog-title'
          open={open9}
          sx={{
            direction: 'rtl',
            '& .MuiDialog-paper': {
              width: '400px',
              zIndex: 100000000000000000,
            },
          }}
        >
          <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose9}>
            {t('screens.CarsScreen.Show_cars_speed')}
          </BootstrapDialogTitle>
          <DialogContent sx={{ p: 1, background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues7}
              onSubmit={handleSubmitSpeedLimitation}
              validationSchema={validationSchema7}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,

                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmitSpeedLimitation}>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_start_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })
                            const a = date.format('YYYY-MM-DD HH:mm')
                            setDate1(a)
                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('startdate', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[<TimePicker key={'extenssion'} position='bottom' />]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={100000000000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.startdate}</div>
                    <InputLabel id='demo-simple-select-label'>
                      {t('screens.CarsScreen.choose_end_date')}:
                    </InputLabel>
                    <Box
                      alignItems='center'
                      display='flex'
                      flexDirection='column'
                      justifyContent='center'
                      sx={{
                        mb: 0,
                        borderRadius: 2,
                        '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                        '& .rmdp-action-button': { fontFamily: 'Vazir' },
                        '& .rmdp-container ': { width: '100%' },
                        '& .rmdp-input': {
                          fontFamily: 'Vazir',
                          minHeight: '49px',
                          width: '100%',
                          border: '1.5px solid black',
                          paddingRight: '11px',
                        },
                      }}
                    >
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '3px',
                          width: '100%',
                        }}
                      >
                        <DatePicker
                          calendar={persian}
                          calendarPosition='top-right'
                          className='rmdp-mobile'
                          format='YYYY/MM/DD'
                          locale={persian_fa}
                          maxDate={new DateObject({ calendar: persian })}
                          minDate={date1}
                          onChange={(e: any) => {
                            const date = new DateObject({
                              calendar: persian,
                              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                              date: `${e.year}-${e.month}-${e.day} ${e.hour}:${e.minute}`,
                            })

                            date.subtract(3, 'hour')
                            date.subtract(30, 'minute')

                            date.convert(gregorian, gregorian_en)
                            setFieldValue('enddate', date.format('YYYY-MM-DD HH:mm'))
                          }}
                          plugins={[
                            <TimePicker
                              key={'extenssion'}
                              position='bottom'
                              style={{ fontFamily: 'Vazir' }}
                            />,
                          ]}
                          render={<InputIcon />}
                          style={{ width: '100%', border: '2px solid #black' }}
                          zIndex={10000000}
                        />
                      </div>
                    </Box>
                    <div style={{ color: 'red', fontSize: '12px' }}>{errors.enddate}</div>

                    <Button
                      fullWidth
                      onClick={(e) => {
                        handleSubmit()
                      }}
                      sx={{ mt: 2 }}
                      variant='contained'
                    >
                      {t('screens.CarsScreen.send')}
                    </Button>
                  </form>
                </>
              )}
            </Formik>
          </DialogContent>
        </BootstrapDialog>
      </div>
    </Box>
  )
}

export default Search
